export default __webpack_public_path__ + "static/media/03.ca4b7661.webp";